import { Lock } from '@/components/Lock';
import { TPage } from '@/types';
import { Typography } from '@data-products-and-ai/react-components';

import gatekeeper from '@/assets/gatekeeper.png';

const returnTeam = (team: string) => {
  if (team === 'red') return <span style={{ color: 'red' }}>TEAM RED</span>;
  if (team === 'yellow')
    return <span style={{ color: 'yellow' }}>TEAM YELLOW</span>;
  if (team === 'blue') return <span style={{ color: 'blue' }}>TEAM BLUE</span>;
  if (team === 'green')
    return <span style={{ color: 'green' }}>TEAM GREEN</span>;
  return null;
};
const Gatekeeper = ({ team }: Partial<TPage>) => {
  if (!team) return null;
  return (
    <div style={{ textAlign: 'center', padding: 20 }}>
      <Typography>
        <div style={{ marginBottom: 20 }}>
          <img src={gatekeeper} alt="" style={{ width: 300, height: 'auto' }} />
        </div>
        Cats have great social skills and, this time, you are required to get a
        little package from our Gatekeeper - the one that controls who can come
        in and out!
        <br />
        <br />
        Just ask for the envelope for {returnTeam(team)} and you will get the
        next clue.
      </Typography>
    </div>

    /*   <Lock
      target={target}
      lockType="image"
      combination="3,0,2,1,4,5,7,6,9,8"
      text={
        <Typography tag="h1">
          Great job so fAr but aRe you All aGain prEpared? Go aROUND the message
          and Find aLl yOu need tO be in the Right path!
        </Typography>
      }
    /> */
  );
};

export default Gatekeeper;
